import { useEffect, useState } from 'react'
import {
  Box,
  Flex,
  Menu,
  MenuItem,
  MenuList,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  MenuButton,
  Button,
  useToast
} from "@chakra-ui/react";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { displayReactIcon } from '../../helpers/dsr-display-helpers';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import { IoChevronDownOutline } from 'react-icons/io5';
import LaunchdeckSwitch from '../../../global/components/helper-components/components/LaunchdeckSwitch';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


export const CustomPageSettingsModal = ({
  pageId,
  showModal,
  pageIcon,
  pageIconColor,
  pageTitle,
  pageDescription,
  displayPage,
  lockedPage,
  handleClosePageSettingsModal,
  handleRemovePage,
  handleEditPageData,
  handleDuplicatePageClick,
  dsrBrandingOptions
}) => {

  const iconSelectionArray = ["customised-page", "circle-check", "folder", "star"]
  const [pageSettingsState, setPageSettingsState] = useState({
    pageName: pageTitle ? pageTitle : '',
    customPageDescription: pageDescription ? pageDescription : '',
    isPageVisible: displayPage,
    isPageLocked: lockedPage ? lockedPage : false
  });
  const [chosenIcon, setChosenIcon] = useState(pageIcon ? pageIcon : 'customised-page')
  const toast = useToast()
  const [chosenIconColor, setChosenIconColor] = useState("");
  const [brandColors, setBrandColors] = useState({})
  const [error, setError] = useState('');

  const nameCharacterLimit = 50;
  const descriptionCharacterLimit = 280;

  useEffect(() => {
    if (displayPage !== pageSettingsState.isPageVisible) {
      setPageSettingsState(prevState => ({
        ...prevState,
        isPageVisible: displayPage
      }))
    }

    if (displayPage !== pageSettingsState.isPageLocked) {
      setPageSettingsState(prevState => ({
        ...prevState,
        isPageLocked: lockedPage
      }))
    }
  }, [displayPage, lockedPage]);

  useEffect(() => {
    if (pageIconColor) {
      setChosenIconColor(pageIconColor)
    }
  }, [pageIconColor]);

  useEffect(() => {
    if (dsrBrandingOptions) {
      setBrandColors(dsrBrandingOptions)
    }
  }, [dsrBrandingOptions]);


  const handleClickClosePageSettingsModal = () => {
    setError('')
    handleClosePageSettingsModal()
  }

  const onChangeHandler = (event) => {
    setError('')
    let allowUpdate = true;

    if (event.target.name === "pageName") {
      if (event.target.value?.length > nameCharacterLimit) {
        allowUpdate = false
      }
    }

    allowUpdate && setPageSettingsState(prevPageSettings => ({
      ...prevPageSettings,
      [event.target.name]: event.target.value
    }))
  };

  const handleSavePageSettings = () => {
    const { pageName, customPageDescription, isPageVisible, isPageLocked } = pageSettingsState;
    if (pageName.length <= 0) {
      setError('pageName')
      return;
    }

    if (customPageDescription.length > descriptionCharacterLimit) {
      setError('pageDescription')
      return;
    }

    if (!error) {
      let customPageData = {};

      if (pageName !== pageTitle) {
        customPageData.pageTitle = pageName;
      }

      if (customPageDescription !== pageDescription) {
        customPageData.pageDescription = customPageDescription;
      }

      if (isPageVisible !== displayPage) {
        customPageData.displayPage = isPageVisible;
        if (isPageVisible === false) {
          customPageData.lockedPage = false;
        }

      }

      if (isPageLocked !== lockedPage) {
        customPageData.lockedPage = isPageLocked;
      }

      if (Object.keys(customPageData).length > 0) {
        handleEditPageData(customPageData, pageId)
      }

      handleClickClosePageSettingsModal()
    }
  }

  const handlePickIcon = (icon) => {
    const isExpectedIcon = iconSelectionArray.includes(icon)

    if (isExpectedIcon) {
      let customPageData = {
        pageIcon: icon
      };

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }
      setChosenIcon(icon)
    }
  }

  const handlePickIconColor = (color) => {

    if (color) {
      let customPageData = {
        pageIconColor: color
      };

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }
      setChosenIconColor(color)
    }
  }

  const handleClickDeletePageButton = () => {
    handleRemovePage(pageId)
    handleClosePageSettingsModal()
  };

  const handleClickDuplicatePageButton = () => {
    handleDuplicatePageClick(pageId)
    handleClosePageSettingsModal()

    toast(
      triggerLaunchdeckToast({
        useCase: "work-in-progress-state",
        label: `${pageTitle} is being duplicated`,
        isMobileView: false
      })
    )
  }

  return (
    <LaunchdeckModal
      title='Page settings'
      handleCloseModal={handleClickClosePageSettingsModal}
      showModal={showModal}
      maxW='35em'
    >
      <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
        <Box width='100%'>
          <Tabs width='100%' py='0.4em'>
            <TabList padding='0 1.5em'>
              <Tab fontSize='0.8em' pr='1em'>General</Tab>
              <Tab fontSize='0.8em' px='1em'>Duplicate page</Tab>
              <Tab fontSize='0.8em' px='1em'>Delete page</Tab>
            </TabList>

            <TabPanels p='1.5em'>
              <TabPanel>
                <Box margin='0px -10px' minH='380px' height='100%' className='fade-in'>
                  <Box px='1em'>
                    <LaunchdeckFormInput
                      label='Page name'
                      name={'pageName'}
                      onChange={onChangeHandler}
                      value={pageSettingsState.pageName}
                      placeholder="Enter page name"
                      isRequired={true}
                      charLimit={nameCharacterLimit}
                      errorLogic={error === 'pageName'}
                      errorMessage={'Give your page a name'}
                    />

                    <Box w='100%' mt='1em' mb='2em'>
                      <Box fontSize='0.7em' letterSpacing='1px' color='brandDark.500' fontWeight='600'>ICON</Box>
                      <Flex gap={4} align='center'>
                        <Flex gap={4} mt='0.5em' w='100%'>
                          {iconSelectionArray?.map(icon => {
                            const isChosenIcon = chosenIcon === icon ? true : false;
                            const iconColor = isChosenIcon ? 'brandDark.500' : 'gray.500'
                            return (
                              <Flex key={`page-icon-${icon}`} cursor='pointer' onClick={() => handlePickIcon(icon)} border='1px solid' bg={isChosenIcon && 'brand.50'} borderColor={isChosenIcon ? 'brand.500' : 'gray.200'} rounded='0.5em' justify='center' align='center' p='0.5em'>
                                {displayReactIcon(icon, '1.5em', "", "", iconColor)}
                              </Flex>
                            )
                          })}
                        </Flex>

                        <Menu closeOnSelect={true} placement="bottom-end">
                          <MenuButton
                            as={Button}
                            w="10em"
                            fontSize="14px"
                            padding="16px 12px"
                            background="rgba(255, 255, 255, 0.92)"
                            border="1px solid #CBD5E0"
                            rounded='1em'
                            {...{
                              rightIcon: <IoChevronDownOutline />
                            }}
                          >


                            <Flex gap={4} justify='flex-start' align='center' >
                              <Box display='flex' boxSize='1em' rounded="full" border='1px solid' borderColor='gray.200' bg={chosenIconColor || 'gray.500'} />
                              <Box fontSize='0.8em'>{chosenIconColor && chosenIconColor === 'brandDark.500' ? "Default" : "Custom"}</Box>
                            </Flex>

                          </MenuButton>
                          <MenuList zIndex={'50'}>
                            <MenuItem name='brandDark.500' className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor('brandDark.500')}>
                              <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                <Box boxSize='1em' rounded='50%' bg='brandDark.500' />
                                <Box fontSize='0.8em'>Default</Box>
                              </Flex>

                            </MenuItem>

                            {brandColors.primaryColor &&
                              <MenuItem name={brandColors.primaryColor} className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor(brandColors.primaryColor)}>
                                <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                  <Box boxSize='1em' rounded='50%' border='1px solid' borderColor='gray.200' bg={brandColors.primaryColor} />
                                  <Box fontSize='0.8em'>Brand color</Box>
                                </Flex>
                              </MenuItem>
                            }

                            {brandColors.secondaryColor &&
                              <MenuItem name={brandColors.secondaryColor} className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor(brandColors.secondaryColor)}>
                                <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                  <Box boxSize='1em' rounded='50%' border='1px solid' borderColor='gray.200' bg={brandColors.secondaryColor} />
                                  <Box fontSize='0.8em'>Accent color</Box>
                                </Flex>
                              </MenuItem>
                            }
                          </MenuList>
                        </Menu>
                      </Flex>
                    </Box>


                    <Box fontSize='0.7em' letterSpacing='1px' color='brandDark.500' fontWeight='600' mt='4em' mb='1em'>PAGE ACCESSIBILITY</Box>

                    <Flex w='100%' justify='space-between' align='center' mb='1.5em'>
                      <Box fontSize='0.8em' fontWeight='500'>Everyone can read this page</Box>
                      <Box display='flex' fontSize='0.875em'>
                        <LaunchdeckSwitch
                          name="isPageVisible"
                          isChecked={pageSettingsState.isPageVisible}
                          onChange={(event) => setPageSettingsState(prevPageSettings => ({
                            ...prevPageSettings,
                            isPageVisible: event.target.checked,
                            ...(event.target.checked === false && { isPageLocked: false })
                          }))}
                          yesContent='"Yes"'
                          noContent='"No"'
                        />
                      </Box>
                    </Flex>



                    <Flex w='100%' justify='space-between' align='center' mb='10px'>
                      <Box fontSize='0.8em' fontWeight='500'>Page locked</Box>
                      <Box display='flex' fontSize='0.875em'>
                        <Box>
                          <LaunchdeckSwitch
                            name="isPageLocked"
                            isChecked={pageSettingsState.isPageLocked}
                            onChange={(event) => setPageSettingsState(prevPageSettings => ({
                              ...prevPageSettings,
                              isPageLocked: event.target.checked
                            }))}
                            yesContent='"Lock"'
                            noContent='""'
                            yesBg="brandDark.500"
                            noBg=""
                          />

                        </Box>
                      </Box>
                    </Flex>

                  </Box>
                  <Flex align='center' justify='flex-end' w='100%' mt='6.5em'>
                    <LaunchdeckButton bg='brandDark.500' color='white' fontSize='0.8em' onClick={handleSavePageSettings} px='0.5em' label='OK' />
                  </Flex>
                </Box>


              </TabPanel>

              <TabPanel>
                <Box margin='0px -10px' minH='380px' height='100%' className='fade-in'>
                  <Flex height='100%' pt='2em' justify='flex-start' alignItems='center' direction='column'>
                    <Box fontSize='20px' fontWeight='600'>Duplicate page</Box>
                    <Box maxWidth='27em' mb='1.5em' mt='1em' textAlign='center' color='#2D3748' fontSize='0.875em'>
                      An exact copy of <strong>{pageTitle}</strong> will be created. Proceed?
                    </Box>
                    <Flex justifyContent='center' m='24px' width='100%' maxWidth='430px'>
                      <Flex
                        justify='center'
                        cursor='pointer'
                        alignItems='center'
                        onClick={handleClickDuplicatePageButton}
                        width={['100%', 'auto']}
                        px={['0', '2em']}
                        py='0.4em'
                        borderRadius='300px'
                        backgroundColor={'brandDark.500'}
                      >
                        <Flex
                          color={'white'}
                          fontSize='0.8em'
                          align='center'
                          gap={4}
                        >
                          {displayReactIcon('add-new-page', '1em')}
                          Duplicate page
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                </Box>
              </TabPanel>

              <TabPanel >
                <Box margin='0px -10px' minH='380px' height='100%' className='fade-in'>
                  <Flex height='100%' pt='2em' justifyContent='flex-start' alignItems='center' flexDirection='column'>
                    <Box fontSize='20px' fontWeight='600'>Remove page</Box>
                    <Box maxWidth='27em' mb='1.5em' mt='1em' textAlign='center' color='#2D3748' fontSize='0.875em'>
                      <i>{pageTitle}</i> and its content will be removed from this Room. Are you sure?
                    </Box>
                    <Flex justifyContent='center' m='24px' width='100%' maxWidth='430px'>
                      <Flex
                        justify='center'
                        cursor='pointer'
                        alignItems='center'
                        onClick={handleClickDeletePageButton}
                        width={['100%', 'auto']}
                        px={['0', '2em']}
                        py='0.4em'
                        borderRadius='300px'
                        backgroundColor={'brandPink.500'}
                      >
                        <Flex
                          color={'white'}
                          fontSize='0.8em'
                          align='center'
                          gap={4}
                        >
                          {displayReactIcon('remove', '1em')}
                          Yes, remove this page
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </LaunchdeckModal>
  )

}
